// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-button',
    // #endregion
    // #region Properties
    props: {
        text: {
            type: String,
            required: false,
            default: ''
        },
        action: {
            type: String,
            required: false,
            default: 'click'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        buttonStyle: {
            type: String,
            required: false,
            default: 'btn-primary'
        },
        class: {
            type: String,
            required: false,
            default: 'w-100'
        }
    },
    data: () => ({
        isLoadingManually: false
    }),
    // #endregion
    // #region Constructor
    created() {
        this.$form = utils.findForm(this);
    },
    // #endregion
    // #region Computed 
    computed: {
        cssClass() {
            return this.class;
        },
        cssStyle() {
            return this.buttonStyle;
        },
        isLoadingInternal() {
            return this.isLoadingManually || this.isLoading;
        }
    },
    methods: {
        OnClickInternal($event) {
            // #region Default
            if (utils.isNullOrEmpty(this.action) || this.action == 'click') {
                //DO nothing
            }
            // #endregion
            // #region Defult
            else {
                this.$form?.eventBus.emit(this.action, { event: $event, sender: this });
            }
            // #endregion
        }
    }
});
// #endregion
